import { render, staticRenderFns } from "./DmsDataForm.vue?vue&type=template&id=0dd464d4&"
import script from "./DmsDataForm.vue?vue&type=script&lang=js&"
export * from "./DmsDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports